// NOTICE: KAPTION-INTEGRATION - Added FOLLOWUP and SCHEDULE modes for utility templates
export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  FOLLOWUP: 'FOLLOWUP',
  SCHEDULE: 'SCHEDULE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
